import { render, staticRenderFns } from "./market.vue?vue&type=template&id=60cedf46"
import script from "./market.vue?vue&type=script&lang=js"
export * from "./market.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports